import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import camelCaseToSnakeCase from '@core/utils/functions/camel-case-to-snake-case';
import { EnumPipe } from '@fuse/pipes/status/status.pipe';
import { TranslateService } from '@ngx-translate/core';
import { concat, orderBy, sortBy } from 'lodash';
import moment from 'moment-timezone';
import { CreateMaintenanceLogsService } from './services/create-maintenance-logs.service';
import { CreateTaskLogsService } from './services/create-task-logs.service';
import { UpdatedByLogService } from './services/updated-by-log.service';
var TabLogsComponent = /** @class */ (function () {
    function TabLogsComponent(data, taskStatusPipe, translateService, updatedByLogService, createMaintenanceLogsService, createTasksLogsService) {
        this.taskStatusPipe = taskStatusPipe;
        this.translateService = translateService;
        this.updatedByLogService = updatedByLogService;
        this.createMaintenanceLogsService = createMaintenanceLogsService;
        this.createTasksLogsService = createTasksLogsService;
        this.todayDate = moment().format('DD/MM/YYYY');
        this.yesterdayDate = moment().subtract(1, 'days').format('DD/MM/YYYY');
        this.logsMapped = [];
        this.logsMappedFiltered = [];
        this.selectOptions = [
            {
                title: this.translateService.instant('MAINTENANCES.TABS.LOGS.FILTER.GENERAL'),
                value: 'general'
            },
            {
                title: this.translateService.instant('MAINTENANCES.TABS.LOGS.FILTER.MAINTENANCE'),
                value: 'maintenance'
            }
        ];
        this.selectValue = new FormControl(this.selectOptions[0]);
        this.maintenanceLogs = data.maintenance.logs || [];
        this.maintenanceTasks = data.maintenance.tasks || [];
    }
    TabLogsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.defineSelectOptions();
        this.createLogsMapped();
        this.filterLogs('general');
        this.selectValue.valueChanges
            .subscribe(function (optionSelected) { return _this.filterLogs(optionSelected.value); });
    };
    TabLogsComponent.prototype.defineSelectOptions = function () {
        var _this = this;
        this.maintenanceTasks.forEach(function (task, taskIndex) {
            var taskStatusTranslated = _this.taskStatusPipe.transform(String(task.status), 'task_status');
            var taskStatusClass = camelCaseToSnakeCase(String(task.status));
            var title = null;
            var _a = task.logs, length = _a.length, _b = length - 1, last = _a[_b];
            if (last && last.snapshot && last.snapshot.archived) {
                title = _this.translateService.instant('MAINTENANCES.TABS.LOGS.FILTER.TASK_ARCHIVED', {
                    taskIndex: taskIndex + 1,
                });
            }
            else {
                title = _this.translateService.instant('MAINTENANCES.TABS.LOGS.FILTER.TASK', {
                    taskIndex: taskIndex + 1,
                    class: taskStatusClass,
                    status: taskStatusTranslated
                });
            }
            _this.selectOptions.push({
                title: title,
                value: "task_" + task.id
            });
        });
    };
    TabLogsComponent.prototype.filterLogs = function (filterLogsBy) {
        if (filterLogsBy === 'general') {
            this.logsMappedFiltered = this.logsMapped;
            return;
        }
        var logsFiltered = this.logsMapped.filter(function (log) { return log.typeLog === filterLogsBy; });
        this.logsMappedFiltered = sortBy(logsFiltered);
    };
    TabLogsComponent.prototype.sortByReverseCreatedAt = function (logs) {
        return orderBy(logs, ['createdAt'], ['desc']);
    };
    TabLogsComponent.prototype.createLogsMapped = function () {
        var maintenanceLogs = this.createMaintenanceLogsService.listMaintenancesLogsMapped(this.maintenanceLogs);
        var tasksLogsMapped = this.createTasksLogsService.listTaskLogsMapped(this.maintenanceTasks);
        var allLogsConcatenated = concat(maintenanceLogs, tasksLogsMapped);
        var allLogsWithChangedBy = this.updatedByLogService.customUpdatedByInLogs(allLogsConcatenated);
        this.logsMapped = this.sortByReverseCreatedAt(allLogsWithChangedBy);
    };
    return TabLogsComponent;
}());
export { TabLogsComponent };
